<template>
    <button type="button" :class="['btn btn-warning mb-0 px-3 me-2', addClass]" @click="showQuestion()" :disabled="disabled">
            شروع روند تاییدات
    </button>
</template>

<script>
    import BaseService from "@/services/Base-service";

    export default {
        name: "StartFlow",
        props: {
            applyDateId: {
                type: Number,
                default: 0,
            },
            question: {
                type: String,
                default: "<b>آیا برای شروع روند تایید اطلاعات ثبت شده اطمینان دارید؟</b>" +
                    " <br/>  <b>توجه</b> داشته باشید که بعد از شروع روند تاییدات، امکان ویرایش اطلاعات میسر نمیباشد. مگر اینکه اطلاعات توسط یکی از تایید کنندگان رد شود.",
            },
            getReason: {
                type: Boolean,
                default: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            parameterGroupEnum: {
                type: Number,
                default: 0,
            },
            addClass: {
                type: String,
                default: 'mt-4',
            }
        },
        emits: ["fnCallback"],
        data() {
            return {
                url: 'Cartabel/StartFlow',
                description: ''
            };
        },
        components: {
        },
        methods: {
            showQuestion() {
                let vm = this;
                this.$swal.fire({
                    title: 'تایید شروع روند',
                    html: `<div>${this.question}</div>` + `<div class="mt-3">توضیحات خود را وارد نمایید :</div>`,
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'انصراف',
                    confirmButtonText: 'بله، شروع شود',
                    reverseButtons: true,
                    input: 'textarea',
                    inputClass: "text-danger",
                    inputValue: "",
                    //inputValidator: (value) => {
                    //    debugger
                    //    alert('asdf');
                    //},
                    preConfirm: (value) => {
                        //else {
                        //    vm.description = value;
                        //}

                        if (vm.applyDateId == 0) {
                            this.$swal.showValidationMessage('<i class="fa fa-info-circle"></i> پارامتر مشخصه اطلاعات ثبت شده به درستی تعیین نشده است');
                            return false;
                        }
                        vm.description = value;
                    }
                })
                    .then((result) => {
                        if (result.isConfirmed) {
                            if (vm.url && vm.url.length > 0) {
                                BaseService.get(vm.removeTrailingSlash(vm.url) + '/' + vm.applyDateId + `/${vm.parameterGroupEnum}/` + (vm.description ?? " "))
                                    .then(response => {
                                        let result = response.data;

                                        if (!result.isSuccess) {
                                            vm.$toast.error(result.message);
                                        }
                                        else {
                                            vm.$toast.success(result.message);
                                            vm.$emit("fnCallback", true);
                                        }
                                    })
                                    .catch(e => {
                                        console.log(e);
                                    });
                            }
                            else {
                                vm.$emit("fnCallback", true);
                            }
                        }
                        else {
                            vm.$emit("fnCallback", false);
                        }
                    })
            },
            removeTrailingSlash(str) {
                return str.replace(/\/+$/, '');
            }
        },
        created() { },
        computed: {
        }
    };
</script>